package one.healthium.profile.di

import one.healthium.profile.ui.avatar.UserAvatarViewModel
import one.healthium.profile.ui.food_history.FoodHistoryViewModel
import one.healthium.profile.ui.profile.ProfileViewModel
import one.healthium.profile.ui.update_age.UpdateAgeViewModel
import one.healthium.profile.ui.update_food.UpdateFoodViewModel
import one.healthium.profile.ui.update_height.UpdateHeightViewModel
import one.healthium.profile.ui.update_initial_weight.UpdateInitialWeightViewModel
import one.healthium.profile.ui.update_name.UpdateNameViewModel
import one.healthium.profile.ui.update_weight.UpdateWeightViewModel
import one.healthium.profile.ui.weight_history.WeightHistoryViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val profileUiModule = module {
    viewModelOf(::ProfileViewModel)
    viewModelOf(::WeightHistoryViewModel)
    viewModelOf(::UpdateWeightViewModel)
    viewModelOf(::FoodHistoryViewModel)
    viewModelOf(::UpdateFoodViewModel)
    viewModelOf(::UpdateNameViewModel)
    viewModelOf(::UpdateAgeViewModel)
    viewModelOf(::UpdateHeightViewModel)
    viewModelOf(::UpdateInitialWeightViewModel)
    viewModelOf(::UserAvatarViewModel)
}